import { Component, inject, Input } from '@angular/core';
import * as d3 from 'd3';
import { DomSanitizer } from '@angular/platform-browser';
import { ItButtonDirective } from 'design-angular-kit';
import { TranslateModule } from '@ngx-translate/core';
import type { HistogramData } from '../interfaces/histogram-data';

@Component({
	selector: 'app-histogram',
	imports: [ItButtonDirective, TranslateModule],
	templateUrl: './histogram.component.html',
	styleUrl: './histogram.component.scss',
})
export class HistogramComponent {
	public sanitizer = inject(DomSanitizer);
	@Input() xLabel = '';
	@Input() yLabel = '';
	svg = '';
	@Input({ required: true }) set data(data: HistogramData[]) {
		console.log(data);
		const width = 1000;
		const height = 500;
		const marginTop = 30;
		const marginRight = 30;
		const marginBottom = 30;
		const marginLeft = 30;
		// Declare the x (horizontal position) scale
		const x = d3
			.scaleBand()
			.domain(data.map((d) => d.label))
			.range([marginLeft, width - marginRight])
			.padding(0.1);
		// Declare the y (vertical position) scale
		const y = d3
			.scaleLinear()
			.domain([0, d3.max(data, (d) => d.value)!])
			.range([height - marginBottom, marginTop]);
		// Create the SVG container
		const svg = d3
			.create('svg')
			.attr('width', width)
			.attr('height', height)
			.attr('viewBox', [0, 0, width, height])
			.attr('style', 'max-width: 100%; height: auto;');
		// Add a rect for each bar
		svg.append('g')
			.attr('fill', 'var(--bs-secondary)')
			.selectAll()
			.data(data)
			.join('rect')
			.attr('x', (d) => x(d.label)!)
			.attr('y', (d) => y(d.value))
			.attr('height', (d) => y(0) - y(d.value))
			.attr('width', x.bandwidth())
			.append('title')
			.text((d) => `${d.label}: ${d.value}`);
		// Add the x-axis and label
		svg.append('g')
			.attr('transform', `translate(0,${height - marginBottom})`)
			.call(d3.axisBottom(x).tickSizeOuter(0))
			.call((g) =>
				g
					.append('text')
					.attr('x', width)
					.attr('y', marginBottom - 4)
					.attr('fill', 'currentColor')
					.attr('text-anchor', 'end')
					.text(this.xLabel),
			);
		// Add the y-axis and label
		svg.append('g')
			.attr('transform', `translate(${marginLeft},0)`)
			.call(d3.axisLeft(y).ticks(d3.max(data, (d) => d.value)!))
			.call((g) =>
				g
					.append('text')
					.attr('x', -marginLeft)
					.attr('y', 10)
					.attr('fill', 'currentColor')
					.attr('text-anchor', 'start')
					.text(this.yLabel),
			);
		const svgNode = svg.node();
		if (svgNode) {
			this.svg = svgNode.outerHTML;
		}
	}
	download() {
		const element = document.createElement('a');
		element.setAttribute(
			'href',
			'data:image/svg+xml,' + encodeURIComponent(this.svg),
		);
		element.setAttribute('download', '');
		element.click();
	}
}
